import { render } from "./Contact.vue?vue&type=template&id=5a435e0c&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=5a435e0c&lang=scss&scoped=true"

import exportComponent from "C:\\Projets\\CasaPortugal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a435e0c"]])

export default __exports__